export const CREATING_PROFILE_ON_BEHALF = 'CREATING_PROFILE_ON_BEHALF'
export const CREATING_PROFILE_ON_BEHALF_SUCCESS = 'CREATING_PROFILE_ON_BEHALF_SUCCESS'
export const CREATING_PROFILE_ON_BEHALF_ERROR = 'CREATING_PROFILE_ON_BEHALF_ERROR'
export const OPEN_CREATING_PROFILE_ON_BEHALF_MODAL = 'OPEN_CREATING_PROFILE_ON_BEHALF_MODAL'
export const CLOSE_CREATING_PROFILE_ON_BEHALF_MODAL = 'CLOSE_CREATING_PROFILE_ON_BEHALF_MODAL'

export const CLEAR_CREATE_PROFILE_ON_BEHALF_NOTIFICATION = 'CLEAR_CREATE_PROFILE_ON_BEHALF_NOTIFICATION'
